import $ from 'jquery';
import { onErrorShowMessage } from '~src/errors';
import { getAxiosClient } from '~src/api';
import { removeTagBackgroundFromCache } from '~src/sidebar/index';

export const deleteTagBackground = async (backgroundId, tagId, isGlobal) => {
  $(`#btn-menu-frames #editor-btn-spinner-${tagId}`).show();
  $(`#delete-tag-${tagId}`).hide();

  const httpClient = await getAxiosClient();
  let table_name = '';
  if (isGlobal === true) {
    table_name = 'editor_backgrounds_default';
  } else {
    table_name = 'editor_backgrounds';
  }
  const url = `${process.env.PARSE_API_URL}/${table_name}/${backgroundId}`;
  const method = 'PUT';
  const data = {
    del_relations: [
      {
        column: 'tags',
        class: 'editor_images_tags',
        toIds: [tagId],
      },
    ],
  };
  try {
    await httpClient({ url, method, data: { data }, responseType: 'json' });
    removeTagBackgroundFromCache(backgroundId, tagId);
  } catch (error) {
    console.error(error);
    onErrorShowMessage();
  }
};
